export default __webpack_public_path__ + "static/media/Hats07.629d1ae7.png";